import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  FormContainer,
  FormTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Select,
  Button,
  RecommendationsContainer,
  RecommendationTitle,
  RecommendationText
} from './FilmRecommendation.styles';

const FilmRecommendationForm = () => {
  const [formData, setFormData] = useState({
    feeling: '',
    genre: '',
    pace: '',
    duration: '',
    familiarity: '',
    company: '',
    recentMovie: '',
    triggers: '',
    style: '',
    era: '',
    foreignLanguage: '',
    streamingServices: ''
  });
  const [recommendations, setRecommendations] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'}/recommendations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const text = await response.text(); // Get the raw response text
      console.log('Raw response:', text); // Log the raw response

      const result = JSON.parse(text); // Parse the JSON response
      setRecommendations(result.recommendation);
    } catch (error) {
      console.error('Error fetching recommendations:', error);
    }
  };

  return (
    <FormContainer>
      <Helmet>
        <title>AI Film Recommendation — MyCinemaDB</title>
        <meta name="description" content="Answer a few questions and let our AI cinephile expert recommend the perfect movie for your mood, genre preference, and streaming services." />
      </Helmet>
      <FormTitle>Find Your Next Movie, With Our AI Cinephile Expert</FormTitle>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>How do you want to feel during/after the movie?</Label>
          <Select name="feeling" value={formData.feeling} onChange={handleChange}>
            <option value="">Select an option</option>
            <option value="love">In Love</option>
            <option value="sad/nostalgic">sad and nostalgic</option>
            <option value="scared">scared</option>
            <option value="happy">happy</option>
            <option value="hyped up">hyped up</option>
            <option value="hopeful">hopeful</option>
            <option value="excited">excited</option>
            <option value="curious">Curious</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Which genres are you usually drawn to, and which do you absolutely want to avoid?</Label>
          <Select name="genre" value={formData.genre} onChange={handleChange}>
            <option value="">Select a genre</option>
            <option value="Horror">Horror</option>
            <option value="Action">Action</option>
            <option value="Drama">Drama</option>
            <option value="Thriller">Thriller</option>
            <option value="Psychological">Psychological</option>
            <option value="Science Fiction">Science Fiction</option>
            <option value="Romance">Romance</option>
            <option value="Comedy">Comedy</option>
            <option value="Indie">Indie</option>
            <option value="Documentary">Documentary</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Do you want something fast-paced and intense, or slower and more contemplative?</Label>
          <Select name="pace" value={formData.pace} onChange={handleChange}>
            <option value="">Select pace</option>
            <option value="Fast Paced Intense">Fast Paced Intense</option>
            <option value="Slower Contemplative">Slower Contemplative</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>How long do you feel comfortable spending on a movie right now?</Label>
          <Select name="duration" value={formData.duration} onChange={handleChange}>
            <option value="">Select duration</option>
            <option value="1 hour">1 hour</option>
            <option value="90 minutes">90 minutes</option>
            <option value="2 hours">2 hours</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Are you looking for something that feels familiar or are you in the mood for something totally different and out of your comfort zone?</Label>
          <Select name="familiarity" value={formData.familiarity} onChange={handleChange}>
            <option value="">Select </option>
            <option value="familiar">Somenthing that feels familiar</option>
            <option value="out of confort">Out of confort Zone</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Are you watching with friends/family or on your own?</Label>
          <Select name="company" value={formData.company} onChange={handleChange}>
            <option value="">Select </option>
            <option value="fam and kids">Family/ kids present</option>
            <option value="family">Family Only Adults</option>
            <option value="partner">Partner</option>
            <option value="friends">Group of friends</option>
            <option value="solo">On your own</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>What is a movie you really enjoyed recently, and what specifically did you like about it?</Label>
          <Input type="text" name="recentMovie" value={formData.recentMovie} onChange={handleChange} />
        </FormGroup>

        <FormGroup>
          <Label>Are there any triggers or content areas you want to avoid?</Label>
          <Select name="triggers" value={formData.triggers} onChange={handleChange}>
            <option value="violence">Violence</option>
            <option value="Nudity">Nudity</option>
            <option value="Gore">Horror Elements (Gore)</option>
            <option value="none">None</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Would you prefer a classic film, something from the last decade, or a brand-new release?</Label>
          <Select name="style" value={formData.style} onChange={handleChange}>
            <option value="violence">Classic Film</option>
            <option value="Nudity">Last Decade</option>
            <option value="Gore">Brand New Release</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Are you open to foreign language films or subtitled/dubbed options?</Label>
          <Select name="foreignLanguage" value={formData.foreignLanguage} onChange={handleChange}>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Which streaming services do you have access to?</Label>
          <Select name="streamingServices" value={formData.streamingServices} onChange={handleChange}>
            <option value="max">HBO Max</option>
            <option value="netflix">Netflix</option>
            <option value="hulu">Hulu</option>
            <option value="Disney">Disney Plus</option>
            <option value="Amazon">Amazon Prime Video</option>
            <option value="apple">Apple Tv</option>
            <option value="Other">Other</option>
          </Select>
        </FormGroup>


        {/* Continue for other questions: familiarity, company, recentMovie, triggers, style, era, foreignLanguage, streamingServices */}

        <Button type="submit">Get Recommendations</Button>
      </Form>

      {recommendations && (
        <RecommendationsContainer>
          <RecommendationTitle>Film Recommendations</RecommendationTitle>
          <RecommendationText>{recommendations}</RecommendationText>
        </RecommendationsContainer>
      )}
    </FormContainer>
  );
};

export default FilmRecommendationForm;